import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

export default function Detail_2({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  const GetScaleText = () => {
    const ranges = item.scale.ranges;
    for (let index = 0; index < ranges.length; index++) {
      const range = ranges[index];
      if (range.isHit) {
        if (item.scale.isHtml) {
          return <div className="_flex-center" dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} />;
        } else {
          return <p className="_detail-2-scale-text text-14 _flex-center mb-0">{range.text}</p>;
        }
      }
    }
  };

  return (
    <Row style={{ height: Number(item.height) }}>
      <Col xs={4}>
        <div className="_scale-detail-text-pdf text-11" dangerouslySetInnerHTML={{ __html: item.lowSideText }} />
      </Col>
      <Col xs={4}>
        <Row className={"justify-content-center"}>
          <Col
            xs={"auto"}
            className={
              "text-20 align-content-center " +
              (isSub ? "_detail-2-sub-scope-name-header" : "_detail-2-scope-name-header")
            }
          >
            {item.name}
          </Col>
          <Col xs={"auto"} className={" ps-0"}>
            <div
              className={
                "_flex-center   text-16 " +
                (isSub ? "_detail-2-sub-scope-score-header" : "_detail-2-scope-score-header")
              }
              style={{ height: "28px", width: "28px" }}
            >
              {elementScore}
            </div>
          </Col>
        </Row>
        <br />
        <Row className={"mb-1"}> {GetScaleText()}</Row>
        <ProgressBar
          variant={isSub ? "sub-scope" : "main-scope"}
          now={elementScore}
          label={`${elementScore}%`}
          style={{ height: "12px" }}
        />
      </Col>
      <Col xs={4}>
        <div
          className="_scale-detail-text-pdf text-11 text-end"
          dangerouslySetInnerHTML={{ __html: item.highSideText }}
        />
      </Col>
    </Row>
  );
}
